import {
  ProductId,
  ProductVariantId,
  StockBalanceId,
  StockLocationId,
} from "../types/ids";

export const stockBalanceIdForSku = (
  productId: ProductId,
  variantId: ProductVariantId | null | undefined,
): StockBalanceId => {
  if (!variantId) {
    return productId as StockBalanceId;
  }
  return `${productId}_${variantId}` as StockBalanceId;
};

export const stockBalanceDocId = (
  stockLocationId: StockLocationId,
  productId: ProductId,
  variantId: ProductVariantId | null | undefined,
): StockBalanceId =>
  `${stockLocationId}_${stockBalanceIdForSku(productId, variantId)}` as StockBalanceId;
